{
  "viewer": {
    "everything": "Everything",
    "thisOrg": "This Organization",
    "federated": "Federated Search",
    "views": "Views",
    "federatedViews": "Federated Views"
  }
}
